import React from "react";  
import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faHome, 
  faChevronRight, 
  faCreditCard, 
  faShoppingCart,
  faServer,
  faBox
} from "@fortawesome/free-solid-svg-icons";
import "./style.css";

const routes = [
  { path: "/", breadcrumb: "Beranda", icon: faHome },
  { path: "/orderdomain", breadcrumb: "Pesan Domain", icon: faServer },
  { path: "/orderhosting", breadcrumb: "Pesan Hosting", icon: faServer },
  { path: "/migrasihosting", breadcrumb: "Migrasi Hosting", icon: faServer },
  { path: "/orderserver", breadcrumb: "Pesan Server", icon: faServer },
  { path: "/orderdomainbackorder", breadcrumb: "Pesan Domain Backorder", icon: faServer },
  { path: "/orderproduct", breadcrumb: "Pesan Product", icon: faBox },
  { path: "/paymentmethod", breadcrumb: "Metode Pembayaran", icon: faCreditCard },
  { path: "/ordersummary", breadcrumb: "Checkout", icon: faShoppingCart },
];

const Breadcrumbs = () => {
  const location = useLocation();
  const { orderProcessName, orderParams } = useSelector((state) => state.cart);

  // Ambil query parameter dari URL
  // const searchParams = new URLSearchParams(location.search);
  // const pid = searchParams.get("pid");
  // const billingcycle = searchParams.get("billingcycle");

  // Tentukan secondary route
  let secondRoute = null;
  let secondRouteLabel = "";
  let secondRouteIcon = faServer;
  if (orderProcessName) {
    const found = routes.find(
      (r) =>
        (orderProcessName === "domain" && r.path === "/orderdomain") ||
        (orderProcessName === "hosting" && r.path === "/orderhosting") ||
        (orderProcessName === "migrasiHosting" && r.path === "/migrasihosting") ||
        (orderProcessName === "vps" && r.path === "/orderserver") ||
        (orderProcessName === "domainBackorder" && r.path === "/orderdomainbackorder") ||
        (orderProcessName === "others" && r.path === "/orderproduct")
    );
    if (found) {
      secondRoute = found.path;
      secondRouteLabel = found.breadcrumb;
      secondRouteIcon = found.icon;
    }
  }

  // Siapkan query string jika perlu
  let secondRouteQuery = "";
  if (
    secondRoute &&
    secondRoute !== "/orderdomain" &&
    orderParams?.pid &&
    orderParams?.billingcycle
  ) {
    secondRouteQuery = `?pid=${encodeURIComponent(orderParams.pid)}&billingcycle=${encodeURIComponent(orderParams.billingcycle)}`;
  }

  // Breadcrumbs hanya untuk path yang valid
  const crumbs = [
    {
      to: "/",
      label: "Beranda",
      icon: faHome,
      className: "text-secondary text-center"
    }
  ];

  if (
    secondRoute &&
    location.pathname !== "/" &&
    location.pathname !== secondRoute &&
    routes.some((r) => r.path === secondRoute)
  ) {
    crumbs.push({
      to: secondRoute + secondRouteQuery,
      label: secondRouteLabel,
      icon: secondRouteIcon,
      className: "text-secondary"
    });
  }

  if (
    (location.pathname === "/paymentmethod" || location.pathname === "/ordersummary") &&
    routes.some((r) => r.path === "/paymentmethod")
  ) {
    crumbs.push({
      to: "/paymentmethod",
      label: "Metode Pembayaran",
      icon: faCreditCard,
      className: "text-secondary"
    });
  }

  if (
    location.pathname === "/ordersummary" &&
    routes.some((r) => r.path === "/ordersummary")
  ) {
    crumbs.push({
      to: "/ordersummary",
      label: "Checkout",
      icon: faShoppingCart,
      className: "fw-bold text-dark"
    });
  } else if (
    location.pathname !== "/" &&
    location.pathname !== secondRoute &&
    location.pathname !== "/paymentmethod" &&
    routes.some((r) => r.path === location.pathname)
  ) {
    const found = routes.find((r) => r.path === location.pathname);
    if (found && found.path !== secondRoute) {
      crumbs.push({
        to: found.path,
        label: found.breadcrumb,
        icon: found.icon,
        className: "fw-bold text-dark"
      });
    }
  }

  // Bold untuk step terakhir
  crumbs.forEach((c, i) => {
    if (i === crumbs.length - 1) {
      c.className = "fw-bold text-dark";
    }
  });

  // Jika path tidak ada di routes, hanya tampilkan Beranda
  if (!routes.some((r) => r.path === location.pathname) && location.pathname !== "/" && location.pathname !== secondRoute) {
    return null;
  }

  // Cek jika sedang di payment atau summary, Beranda jadi non-link
  const isNonLinkHome = location.pathname === "/paymentmethod" || location.pathname === "/ordersummary";

  return (
    <nav aria-label="breadcrumb" className="breadcrumb-wrapper">
      <ol className="breadcrumb d-flex align-items-center justify-content-center">
        {crumbs.map((crumb, idx) => (
          <li
            key={crumb.to}
            className={`breadcrumb-item ${idx === crumbs.length - 1 ? "active" : ""}`}
            aria-current={idx === crumbs.length - 1 ? "page" : undefined}
          >
            {idx !== 0 && (
              <FontAwesomeIcon icon={faChevronRight} className="mx-2 text-muted" size="sm" />
            )}
            {/* Jika Beranda dan sedang di payment/summary, tampilkan span, bukan NavLink */}
            {idx === 0 && isNonLinkHome ? (
              <span className={`breadcrumb-link ${crumb.className}`}>
                {crumb.icon && <FontAwesomeIcon icon={crumb.icon} />}
                {crumb.label}
              </span>
            ) : idx !== crumbs.length - 1 ? (
              <NavLink to={crumb.to} className={`breadcrumb-link ${crumb.className}`}>
                {crumb.icon && <FontAwesomeIcon icon={crumb.icon} />}
                {crumb.label}
              </NavLink>
            ) : (
              <span className={`breadcrumb-link ${crumb.className}`}>
                {crumb.icon && <FontAwesomeIcon icon={crumb.icon} />}
                {crumb.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
